var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsharpDotnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "C# / .NET",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68217a",
    d: "M32 3l25 14.5v29L32 61 7 46.5v-29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b4f96",
    d: "M32 3l25 14.5L32 32 7 17.5z",
    opacity: 0.55
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 41,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#fff"
  }, "C#")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharpDotnet);
export default __webpack_public_path__ + "static/media/csharp-dotnet.e4e64f97b6f19e1055c8a49724eea252.svg";
export { ForwardRef as ReactComponent };